import getName from '../../../../../helpers/getName';

export const generateExecuters = (map) => (request) => {
  const { executer } = request;
  const id = executer?.id || 0;

  const entity = map.get(id) || {
    name: executer ? getName(executer) : 'Не указан',
    amount: 0,
    speciality: executer?.speciality,
    id,
  };

  entity.amount += 1;

  map.set(id, entity);
};
